import { useIntl } from 'react-intl';
import { Stack, ToggleButton, ToggleButtonGroup } from '@rossum/ui/material';

type SchemaView = 'editor' | 'diff';

type Props = {
  activeView: SchemaView;
  onViewChange: (view: SchemaView) => void;
};

export const SchemaViewSwitcher = ({ activeView, onViewChange }: Props) => {
  const intl = useIntl();

  return (
    <Stack sx={{ pr: 2 }}>
      <ToggleButtonGroup
        value={activeView}
        exclusive
        onChange={(_, value: SchemaView) => {
          if (value !== null) {
            onViewChange(value);
          }
        }}
        color="primary"
        size="small"
      >
        {(['editor', 'diff'] as const).map(viewType => (
          <ToggleButton
            key={viewType}
            value={viewType}
            aria-label={viewType}
            sx={{ px: 2 }}
            data-cy={`schema-${viewType}-view`}
            color="secondary"
          >
            {intl.formatMessage({
              id: `features.schemaEditor.view.${viewType}`,
            })}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};
